import { render, staticRenderFns } from "./ScheduleIndex.vue?vue&type=template&id=4bd09e42&scoped=true&"
import script from "./ScheduleIndex.vue?vue&type=script&lang=ts&"
export * from "./ScheduleIndex.vue?vue&type=script&lang=ts&"
import style0 from "./ScheduleIndex.vue?vue&type=style&index=0&id=4bd09e42&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bd09e42",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
installComponents(component, {VContainer,VTab,VTabs})
